import { collection, doc, getFirestore, onSnapshot } from 'firebase/firestore'
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import firebase from '../config/firebase'
import { userAtom } from '../recoil/atoms'

const db = getFirestore(firebase)

const useFirebaseSubscription = () => {
  const [user, setUser] = useRecoilState(userAtom)

  useEffect(() => {
    const userRef = user.uid ? doc(collection(db, 'users'), user.uid) : null

    if (!userRef) return

    // This will subscribe to the document and will return an unsubscribe function
    const unsubscribe = onSnapshot(userRef, docSnapshot => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data()
        setUser({
          ...user,
          name: data.name,
          credits: data.credits,
          email: data.email,
          is_plus: data.is_plus,
          liked_ideas: data.liked_ideas,
          votes: data.votes,
          theme: data.theme,
        })
      }
    })

    // Cleanup: unsubscribe from the document when the component is unmounted
    return () => unsubscribe()
  }, [user.uid])

  return user
}

export default useFirebaseSubscription
